import { createAsyncThunk } from "@reduxjs/toolkit";
import apiConfig from "constants/apiConfig";
import { fetchCampaignCreateData, fetchCampaignDetails as fetchCampaignDetailsAPI, fetchCampaignScreeningQuestions } from "services/api/campaign";
import { ERROR } from "types";
import { Campaign } from "types/campaign";
import { GigType, GigTypeProperty } from "types/campaign/collaborations";
import { CampaignDetailsSlice, CampaignGoal, ScreeningQuestion } from "types/campaign/details";
import { getErrorMessage } from "utils/helpers";

export const fetchCampaignDetails = createAsyncThunk<
    { campaign: Campaign, properties: GigTypeProperty[], gig_types: GigType[], goal_list: Record<string, CampaignGoal> },
    string,
    { rejectValue: string }
>(
    'campaign/details/edit',
    async (campaignId, { rejectWithValue }) => {
        try {
            const { campaign, properties, gig_types, goal_list } = await fetchCampaignDetailsAPI(campaignId);
            return { campaign, properties, gig_types, goal_list };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
);

export const fetchCampaignCreateDetails = createAsyncThunk<
    { properties: GigTypeProperty[], gig_types: GigType[], goal_list: Record<string, CampaignGoal> },
    void,
    { rejectValue: string }
>(
    'campaign/create',
    async (_, { getState, rejectWithValue }) => {
        const state = getState() as { campaignDetails: CampaignDetailsSlice };
        const staleTime = apiConfig.FETCH_CAMPAIGN_CREATE_DATA.staleTime;
        if (state.campaignDetails.campaigns['create'] && (Date.now() - state.campaignDetails.campaigns['create'].last_fetched_at) < staleTime) {
            return {
                properties: state.campaignDetails.campaigns['create'].properties,
                gig_types: state.campaignDetails.campaigns['create'].gig_types,
                goal_list: state.campaignDetails.campaigns['create'].goal_list
            };
        }
        try {
            const { properties, gig_types, goal_list } = await fetchCampaignCreateData();
            return { properties, gig_types, goal_list };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
);

export const fetchCampaignScreeningQuestionsThunk = createAsyncThunk<
    { questions: ScreeningQuestion[], campaignId: string },
    string,
    { rejectValue: string }
>(
    'campaign/screening-questions',
    async (campaignId, { rejectWithValue }) => {
        try {
            const { questions } = await fetchCampaignScreeningQuestions(campaignId);
            return { questions, campaignId };
        } catch (error) {
            return rejectWithValue(getErrorMessage(error, ERROR.NOT_FOUND));
        }
    }
);
